/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetClientTeamSettingsRequest
 */
export interface GetClientTeamSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof GetClientTeamSettingsRequest
     */
    clientCompanyId: string;
}

/**
 * Check if a given object implements the GetClientTeamSettingsRequest interface.
 */
export function instanceOfGetClientTeamSettingsRequest(value: object): value is GetClientTeamSettingsRequest {
    if (!('clientCompanyId' in value) || value['clientCompanyId'] === undefined) return false;
    return true;
}

export function GetClientTeamSettingsRequestFromJSON(json: any): GetClientTeamSettingsRequest {
    return GetClientTeamSettingsRequestFromJSONTyped(json, false);
}

export function GetClientTeamSettingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetClientTeamSettingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientCompanyId': json['clientCompanyId'],
    };
}

export function GetClientTeamSettingsRequestToJSON(value?: GetClientTeamSettingsRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientCompanyId': value['clientCompanyId'],
    };
}

